import React from 'react'
import { LuX } from 'react-icons/lu';

const Dialog = ({ open, onClose, title, subtitle, footer, children, widthClass = "sm:max-w-2xl" }) => {
   if (!open) return null;
    return (
      <div
        className="fixed inset-0 z-50 flex items-end justify-center bg-slate-900/50 p-0 backdrop-blur-sm sm:items-center sm:p-4"
        onClick={onClose}
      >
        <div
          className={`flex max-h-[94vh] w-full flex-col overflow-hidden rounded-t-2xl bg-white shadow-2xl sm:max-h-[88vh] sm:rounded-2xl ${widthClass}`}
          onClick={(e) => e.stopPropagation()}
        >
          <div className="flex items-start justify-between gap-3 border-b border-slate-100 px-4 py-3.5 sm:px-6 sm:py-4">
            <div className="min-w-0">
              <h2 className="truncate text-[15px] font-semibold text-slate-900 sm:text-base">{title}</h2>
              {subtitle && <p className="mt-0.5 truncate text-[12px] text-slate-500">{subtitle}</p>}
            </div>
            <button
              onClick={onClose}
              className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg text-slate-400 transition hover:bg-slate-100 hover:text-slate-600"
              aria-label="Close"
            >
              <LuX size={18} />
            </button>
          </div>
   
          <div className="flex-1 overflow-y-auto px-4 py-4 sm:px-6 sm:py-5">{children}</div>
   
          {footer && <div className="border-t border-slate-100 bg-white px-4 py-3 sm:px-6 sm:py-3.5">{footer}</div>}
        </div>
      </div>
    );
}

export default Dialog